import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldAlert, TrendingUp, Zap, AlertCircle } from 'lucide-react';

const Urgence = () => {
  const points = [
    {
      title: "Élargissement de la menace",
      desc: "Les cyberattaques ne ciblent plus uniquement les grands groupes ; elles frappent désormais toutes les structures sans distinction.",
      icon: ShieldAlert
    },
    {
      title: "Vulnérabilité des PME",
      desc: "Les PME et structures récentes sont aujourd’hui des cibles privilégiées car elles sont souvent moins protégées face aux intrusions.",
      icon: TrendingUp
    },
    {
      title: "Coût de l'inaction",
      desc: "Attendre de subir une compromission coûte systématiquement plus cher que la mise en place d'une prévention offensive.",
      icon: Zap
    }
  ];

  return (
    <section className="w-full bg-white py-14 px-6 md:py-20 overflow-hidden border-t border-slate-100 font-inter">
      <div className="max-w-[950px] mx-auto">
        
        {/* Header - Plus compact */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12"
        >
          <div className="flex items-center gap-2 mb-3">
            <AlertCircle size={14} className="text-[#3b82f6]" />
            <span className="text-[#3b82f6] text-[10px] font-black uppercase tracking-[0.25em]">
              Fenêtre d'exposition
            </span>
          </div>
          
          <h2 className="text-[#0f172a] text-[28px] md:text-[34px] font-[900] leading-tight tracking-tight mb-4">
            Pourquoi agir maintenant ?
          </h2>
          <div className="w-12 h-[2.5px] bg-[#3b82f6] rounded-full" />
        </motion.div>

        {/* Grille d'Urgence - Gaps réduits */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {points.map((point, i) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="flex flex-col relative"
              >
                {/* Numérotation réduite */}
                <span className="absolute -top-3 -left-1 text-[45px] font-black text-slate-50 select-none -z-0">
                  0{i + 1}
                </span>

                <div className="relative z-10 text-[#3b82f6] mb-4">
                  <Icon size={24} strokeWidth={2.5} />
                </div>
                
                <h3 className="relative z-10 text-[#0f172a] text-[17px] font-black mb-2 leading-tight">
                  {point.title}
                </h3>
                
                <p className="relative z-10 text-slate-500 text-[13.5px] leading-relaxed font-medium">
                  {point.desc}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* Bloc de renforcement - Taille ajustée */}
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mt-14 p-6 bg-[#0f172a] rounded-[1.5rem] border border-slate-200 shadow-xl shadow-blue-900/5 flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-blue-500/10 flex items-center justify-center text-blue-400 shrink-0">
              <Clock size={18} />
            </div>
            <p className="text-blue-50 text-[14px] md:text-[15px] font-bold italic">
              "La question n'est plus de savoir si vous serez ciblé, mais quand."
            </p>
          </div>
          
          <div className="px-3 py-1.5 bg-blue-500/20 border border-blue-400/30 rounded-full shrink-0">
            <span className="text-blue-300 text-[9px] font-black uppercase tracking-widest">Alerte Risque Actif</span>
          </div>
        </motion.div>
        
      </div>
    </section>
  );
};

export default Urgence;